import { render, staticRenderFns } from "./TransportistaGrid.vue?vue&type=template&id=3f10cebc&scoped=true&"
import script from "./TransportistaGrid.vue?vue&type=script&lang=js&"
export * from "./TransportistaGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10cebc",
  null
  
)

/* custom blocks */
import block0 from "./TransportistaGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports